import { FormattedMessage, useIntl } from 'react-intl';

import Helmet from 'Components/Helmet';
import LoadingSite from 'Components/LoadingSite';

import EmailStep from './EmailStep';
import TokenStep from './TokenStep';
import MarketingPanel from './MarketingPanel';
import LoginFooter from './LoginFooter';
import { useSignInFlow } from './useSignInFlow';

const fallbackLogo = 'https://cream-media.nuimarkets.com/logo/signin/nui.png';

const SignIn = () => {
  const { formatMessage } = useIntl();
  const flow = useSignInFlow();

  if (flow.showInitialLoader) return <LoadingSite />;

  return (
    <>
      <Helmet>
        <title>
          {formatMessage({
            id: 'sign-in-page-meta-title',
            defaultMessage: 'Sign in',
          })}
        </title>
      </Helmet>

      <div className="tw tw:min-h-screen tw:flex tw:bg-white">
        <div className="tw:flex tw:flex-col tw:flex-1">
          <main className="tw:flex tw:flex-1 tw:items-center tw:justify-center tw:px-6 tw:py-12">
            <div className="tw:w-full tw:max-w-md tw:text-center">
              <h1 className="tw:text-3xl tw:font-light tw:text-gray-600 tw:mb-10 tw:text-center">
                <FormattedMessage
                  id="sign-in-page-title"
                  defaultMessage="Please sign in"
                />
              </h1>

              <img
                src={`https://cream-media.nuimarkets.com/logo/signin/${
                  flow.solution || 'nui'
                }.png`}
                alt="Nui Markets"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = fallbackLogo;
                }}
                className="tw:mx-auto tw:mb-10 tw:max-h-48 tw:max-w-[260px] tw:mix-blend-multiply"
              />

              {flow.step === 1 ? (
                <EmailStep {...flow.emailStep} />
              ) : (
                <TokenStep {...flow.tokenStep} />
              )}
            </div>
          </main>
          <LoginFooter />
        </div>

        <MarketingPanel />
      </div>
    </>
  );
};

export default SignIn;
